import { render } from "./UIConfig.vue?vue&type=template&id=f1cef226&scoped=true"
import script from "./UIConfig.vue?vue&type=script&lang=js"
export * from "./UIConfig.vue?vue&type=script&lang=js"

import "./UIConfig.vue?vue&type=style&index=0&id=f1cef226&scoped=true&lang=css"

import exportComponent from "/Users/reinlabares/Labs/imwt/crawl-ui/crawl-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1cef226"]])

export default __exports__